import { HOME_PAGE_OPTIONS, type HomePageOption, type MeResponse, type PermissionKey } from '@bm/contracts';

export const HOME_PAGE_LABELS: Record<HomePageOption, string> = {
  dashboard: 'Dashboard',
  training: 'Training',
  season: 'Saison',
  calendar: 'Kalender',
};

const HOME_PAGE_PATHS: Record<HomePageOption, string> = {
  dashboard: '/',
  training: '/training',
  season: '/season',
  calendar: '/calendar',
};

/** Undefined = immer sichtbar (Dashboard), sonst die Berechtigung, die
 * `AppShell.tsx`s Navigation für denselben Punkt voraussetzt. */
const HOME_PAGE_PERMISSIONS: Partial<Record<HomePageOption, PermissionKey>> = {
  training: 'training.view',
  season: 'season.view',
  calendar: 'calendar.view',
};

/** Welche Startseiten-Optionen der Benutzer im gerade aktiven Verein
 * überhaupt sehen darf — für das Auswahlfeld im Profilmenü und für den
 * Login-Redirect (siehe `resolveHomePagePath`). */
export function availableHomePageOptions(me: MeResponse | null): HomePageOption[] {
  if (!me) return ['dashboard'];
  return HOME_PAGE_OPTIONS.filter((option) => {
    const perm = HOME_PAGE_PERMISSIONS[option];
    return !perm || me.permissions.includes(perm);
  });
}

/** Zielroute direkt nach dem Login: die gespeicherte Präferenz, sofern der
 * Benutzer sie im gerade aktiven Verein tatsächlich sehen darf — sonst der
 * Dashboard-Fallback. Wird bewusst hier statt serverseitig entschieden, weil
 * die Präferenz global pro Benutzerkonto gilt, die sichtbaren Seiten aber vom
 * gerade aktiven Verein abhängen (kann sich zwischen zwei Logins ändern). */
export function resolveHomePagePath(me: MeResponse | null): string {
  const pref = me?.user.homePage;
  if (pref && availableHomePageOptions(me).includes(pref)) return HOME_PAGE_PATHS[pref];
  return '/';
}
